import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import Spinner from "../../components/helpers/Spinner";
import ResponsiveModalAbsolute from "../../components/ResponsiveModalAbsolute";
import { fetchAxiosNoToken } from "../../helpers/fetchAxiosNoToken";
import { fetchAxiosToken } from "../../helpers/fetchAxiosToken";
import { useAppDispatch, useAppSelector } from "../../hooks/hooks";
import { useDispatchDominio } from "../../hooks/useDispatchDominio";
import { getHouse } from "../../redux/reducers/onboardingReducer";
import { useParams } from "react-router-dom";

interface Props {
    modalVisible: boolean;
    setModalVisible: (s: boolean) => void;
    precio_base: string;
    id_tour: number;
    personas: string;
}

export interface PrecioBase {
    precio_base: string;
    personas: string;
}

export const ModalEditPrecioPersonasTour = ({
    modalVisible,
    setModalVisible,
    precio_base,
    personas,
    id_tour,
}: Props) => {
    const { tipo_moneda, id: casa_id } = useAppSelector(
        (state) => state.landing_house.house
    );

    const dispatchDominio = useDispatchDominio();

    const [saving, setSaving] = useState<boolean>(false);
    const [input, setInput] = useState<PrecioBase>({
        precio_base: precio_base,
        personas,
    });

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInput({
            ...input,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async () => {
        if (Number(input.precio_base) === 0)
            return Swal.fire({
                confirmButtonColor: "#029BFC",
                iconColor: "#029BFC",
                title: "El precio base debe ser mayor a cero (0)",
                icon: "warning",
                confirmButtonText: "Aceptar",
            });

        if (Number(input.personas) === 0)
            return Swal.fire({
                confirmButtonColor: "#029BFC",
                iconColor: "#029BFC",
                title: "El número de personas debe ser mayor a cero (0)",
                icon: "warning",
                confirmButtonText: "Aceptar",
            });

        try {
            setSaving(true);
            await fetchAxiosToken({
                url: `/hoteles_tours/updatePrecio/${id_tour}`,
                method: "put",
                body: input,
            });

            dispatchDominio();
            setTimeout(() => {
                Swal.fire({
                    confirmButtonColor: "#029BFC",
                    iconColor: "#029BFC",
                    title: "Actualizado",
                    text: "Habitación actualizada",
                    icon: "success",
                    confirmButtonText: "Ok",
                });
                setSaving(false);

                setModalVisible(false);
            }, 2000);
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <ResponsiveModalAbsolute
            modalVisible={modalVisible}
            setModalVisible={setModalVisible}>
            <div className="flex flex-col items-center justify-center max-w-lg gap-4 p-4 mx-auto text-gray-600">
                <h2 className="2xl:text-4xl text-3xl text-[#1C4CBB] text-center font-medium">
                    Editar Precio Base y número de personas
                </h2>
                <hr className="w-full bg-gray-300" />

                {/* Contenedor de ambos campos */}
                <div className="flex flex-col items-center w-full gap-6">
                    {/* Precio por persona */}
                    <div className="flex flex-col items-center w-full">
                        <label className="text-lg font-medium text-center 2xl:text-xl">
                            Precio por persona
                        </label>
                        <div className="relative flex items-center justify-center gap-2 mt-2">
                            <input
                                type="number"
                                min={0}
                                name="precio_base"
                                value={input.precio_base}
                                onChange={handleInputChange}
                                placeholder="Ingresa el precio por base"
                                className="w-40 2xl:p-3 p-2 2xl:text-base text-sm text-black border border-[#1C4CBB] rounded-lg placeholder:italic"
                            />
                            <div className="absolute text-xl font-bold text-gray-800 left-44">
                                {tipo_moneda}
                            </div>
                        </div>
                    </div>

                    {/* Número de personas */}
                    <div className="flex flex-col items-center w-full">
                        <label className="text-lg font-medium text-center 2xl:text-xl">
                            Número de personas
                        </label>
                        <input
                            type="number"
                            min={0}
                            name="personas"
                            value={input.personas}
                            onChange={handleInputChange}
                            placeholder="Ingresa número de personas"
                            className="w-40 2xl:p-3 p-2 2xl:text-base text-sm mt-2 text-black border border-[#1C4CBB] rounded-lg placeholder:italic"
                        />
                    </div>
                </div>

                {/* Botón */}
                <div className="w-10/12 mt-4 2xl:mt-8">
                    {saving ? (
                        <Spinner />
                    ) : (
                        <button
                            onClick={() => handleSubmit()}
                            className="w-full p-3 px-5 text-white rounded-lg bg-[#1C4CBB] hover:scale-105 2xl:text-base text-sm">
                            Guardar cambios
                        </button>
                    )}
                </div>
            </div>
        </ResponsiveModalAbsolute>
    );
};
